<template>
    <input type="text" />
</template>

<script>
export default {
  name: "FormTextInput",
  props: {},
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
input {
    width: 100%;
    background-color: $white;
    color: $black;
    outline: 0;
    border: none;
    padding: $padding-input-top $padding-input-left $padding-input-bottom;

    font-size: $font-size-md;
    font-weight: 400;
    border-radius: $border-radius-md;
    border: 1px solid $border-divide;
    transition: $transition-simple-fast;
    box-sizing: border-box;
    caret-color: $blue-navy;
    box-shadow: none;
    margin-bottom: $padding-lg;
    &:focus {
        border-color: $blue-navy;
        background-color: $white;
    }
}
</style>
